import { TeContainer, TeDivider } from '@topcon/tuicl-react';
import { use, useState } from 'react';

import { ReviewResultContext } from '../../../providers/ReviewResultContext/review-result.context';
import { ReviewResultContextType } from '../../../providers/ReviewResultContext/review-result.types';
import { ReviewCompanyCreationRequestStepActions } from './ReviewCompanyCreationRequestStepActions';
import { EulaView } from '../../Eula';

interface ReviewRequestBusinessPartnerTermsAndConditionsStepProps {
  id: string;
  visible: boolean;
  onNextStep: () => void;
  onPreviousStep?: () => void;
}

function ReviewRequestBusinessPartnerTermsAndConditionsStep({
  id,
  visible,
  onNextStep,
  onPreviousStep,
}: ReviewRequestBusinessPartnerTermsAndConditionsStepProps) {
  const { setResult } = use<ReviewResultContextType>(ReviewResultContext);
  const [eulaDisclaimerAccepted, setEulaDisclaimerAccepted] = useState<boolean>(false);

  if (!visible) return;

  const handleReject = () => {
    setResult('declined');
  };

  return (
    <TeContainer justifyContent="space-between" fill padding={0} gap={0} column borderRadius={'m'}>
      <EulaView onChecked={(checked) => setEulaDisclaimerAccepted(checked)} />
      <TeDivider dividerColor="border.secondary" />
      <ReviewCompanyCreationRequestStepActions
        step="termsAndConditions"
        id={id}
        onNextStep={onNextStep}
        onPreviousStep={onPreviousStep}
        onReject={handleReject}
        isNextStepDisabled={!eulaDisclaimerAccepted}
      />
    </TeContainer>
  );
}

export default ReviewRequestBusinessPartnerTermsAndConditionsStep;
